import { ChainID } from '@ankr.com/chains-list';

import {
  tacTendermintRpcChains,
  tacTendermintRestChains,
} from 'modules/endpoints/constants/groups';
import { EndpointGroup } from 'modules/endpoints/types';

const isTacTendermintRpc = (group: EndpointGroup) =>
  tacTendermintRpcChains.includes(group.id as unknown as ChainID);

const isTacTendermintRest = (group: EndpointGroup) =>
  tacTendermintRestChains.includes(group.id as unknown as ChainID);

const RPC_STRING = ' RPC';

export const mergeTacTendermintGroups = (groups: EndpointGroup[]) => {
  const tacTendermintRpc = groups.find(isTacTendermintRpc);

  const tacTendermintRest = groups.find(isTacTendermintRest);

  const hasBoth = Boolean(tacTendermintRpc) && Boolean(tacTendermintRest);

  if (hasBoth) {
    return groups
      .filter(group => !isTacTendermintRest(group))
      .map(group => {
        const isTacTendermint = isTacTendermintRpc(group);

        if (isTacTendermint) {
          return {
            ...group,
            chainName: group.chainName.replace(RPC_STRING, ''),
            name: 'Tendermint',
            pluralName: 'Tendermint',
            urls: [
              ...(tacTendermintRpc?.urls || []),
              ...(tacTendermintRest?.urls || []),
            ],
            urlsCount:
              (tacTendermintRpc?.urlsCount || 0) +
              (tacTendermintRest?.urlsCount || 0),
          };
        }

        return group;
      });
  }

  return groups;
};
